<h2 mat-dialog-title [innerHTML]="sanitizedData(data.title)"></h2>
<div mat-dialog-content [innerHTML]="sanitizedData(data.message)"></div>
<div mat-dialog-actions fxLayoutAlign="center" style="margin-top: 4px;">
  <button mat-raised-button [mat-dialog-close]="false">No</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">Yes</button>
</div>
